import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);
let tween = '';

if ($('.crawl-wrapper').length > 0) {
    tween = gsap.to('.crawl-wrapper', {
        x: '-200vw', repeat: -1, duration: 60, ease: 'linear',
    }).totalProgress(0.75).pause();

    gsap.set('.crawl-wrapper', { x: '500vw' });
}

function marqueeScroll() {
    // Check if touch device (mobile)
    const isMobile = ScrollTrigger.isTouch === 1;

    console.log('News panel - isMobile:', isMobile, 'ScrollTrigger.isTouch:', ScrollTrigger.isTouch);

    if (isMobile) {
        // Mobile: simple auto-play at 2x speed (always on)
        console.log('Setting up mobile marquee - auto-play mode');
        tween.timeScale(2);
        tween.play();
        console.log('Mobile marquee started');
    } else {
        // Desktop: scrub-based animation
        console.log('Setting up desktop marquee');
        const crawlTl = gsap.timeline({
            scrollTrigger: {
                trigger: '.latest-news-panel',
                scrub: true,
                start: 'top 90%',
                end: 'bottom top',
                onUpdate: (self) => {
                    if (self.direction === 1) {
                        gsap.to(tween, {
                            timeScale: 1,
                        });
                    } else {
                        gsap.to(tween, {
                            timeScale: -1,
                        });
                    }
                },
                onEnter: () => {
                    tween.play();
                },
                onEnterBack: () => {
                    tween.play();
                },
                onLeave: () => {
                    tween.pause();
                },
                onLeaveBack: () => {
                    tween.pause();
                },
            },
        });

        return crawlTl;
    }
}

if ($('.crawl-wrapper').length > 0) {
    marqueeScroll();
}
